a.router = (function(){
	var my = {
		defloc:'/',
		init:function(){
			window.addEventListener('hashchange', function(e){
				document.title = 'Itefy Go';
				my.parseHash(window.location.hash.substring(1),e.oldURL.split("#")[1]);
				my.changeActiveMenu(window.location.hash.substring(1));
			});
			my.parseHash(window.location.hash.substring(1),'/');
			my.changeActiveMenu(window.location.hash.substring(1));

			//a.item.display.popup(70);

		},
		parseHash:function(inp,lasthash){
			if (!inp) {
				window.location.hash = a.router.defloc;
			}
			else {
				var parts = inp.split('/').filter(function(e){return e != ''});
				var lhparts = [];
				if (!(typeof(lasthash)==='undefined')) {
					lhparts = lasthash.split('/').filter(function(e){return e != ''});
				}
				if (parts.length > 0) {
					if (parts[0] == 'item') {
						if (parts[1] == 'list') {
							a.item.list.page();
						}
					}
					else if (parts[0] == 'reservation') {
						if (parts[1] == 'list') {
							a.reservation.list.page({});
						}
					}
					else if (parts[0] == 'checkout') {
						if (parts[1] == 'list') {
							a.checkout.list.page({});
						}
					}
					else if (parts[0] == 'event') {
						if (parts[1] == 'list') {
							a.event.list.page({});
						}
					}
					else if (parts[0] == 'issue') {
						if (parts[1] == 'list') {
							a.issue.list.page({});
						}
					}
					else if (parts[0] == 'condition') {
						if (parts[1] == 'changes') {
							a.condition.changes.page({});
						}
					}
					else if (parts[0] == 'inventory') {
						if (parts[1] == 'changes') {
							a.inventory.changes.page({});
						}
					}
					else if (parts[0] == 'location') {
						if (parts[1] == 'changes') {
							a.location.changes.page({});
						}
						else if (parts[1] == 'list') {
							a.location.list.page({});
						}
					}
					else if (parts[0] == 'notification') {
						if (parts[1] == 'list') {
							a.notification.list.page();
						}
					}
					else if (parts[0] == 'me') {
						a.me.page();
					}
					else if (parts[0] == 'popupid') {
						// Do nothing, just for closing purpose
					}
					else {
						window.location.hash = a.router.defloc;
					}
				}
				else {
					a.page({tpl:'dashboard',data:{},ready:function(){
						
					}});
				}
				// Hash leave events
				if (lhparts.length > 0) {
					if (lhparts[0] == 'popupid' && parts[0] == 'popupid') {
						// Multiple popups
						a.popup.canRemoveLastWin(lhparts[1],parts[1],function(){
							a.popup.remove(lhparts[1],function(){
								a.popup.runOnRemove(lhparts[1]);
							});
						});
					}
					else if (lhparts[0] == 'popupid') {
						// Only prev is popup, remove
						a.popup.remove(lhparts[1],function(){
							a.popup.runOnRemove(lhparts[1]);
						});
					}
				}
			}
		},
		changeActiveMenu:function(inp){
			var parts = inp.split('/').filter(function(e){return e != ''});
			$('#bmenu ul>li').removeClass('active');
			if (parts[0] == 'item') {
				$('li[data-menu-id="item"]','#bmenu').addClass('active');
			}
			else if (parts[0] == 'notification') {
				$('li[data-menu-id="notification"]','#bmenu').addClass('active');
			}
			else if (parts[0] == 'me') {
				$('li[data-menu-id="me"]','#bmenu').addClass('active');
			}
			else if (parts[0] == undefined) {
				$('li[data-menu-id="dashboard"]','#bmenu').addClass('active');
			}
		}
	}
	return my;
}());